import type { HfsAction, Status } from 'fleet-data-model';
import { createAction } from '@reduxjs/toolkit';
import type {
  AssetConnectivityUpdatedPayload,
  AssetPowerUpdatedPayload,
} from '@fleet-websocket-service/api-contract';
import type { DeepPartial } from '~/types/helper.types';
import type { MachineOwnershipData, LocationFields } from '~/data/Asset';
import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';

const prefix = getCurrentDirname(__dirname);

export const updateAsset = createAction<{
  assetId: AssetId;
  asset: AssetListItem;
  forceUpdate: boolean;
}>(`${prefix}/UPDATE_ASSET`);

export const partialUpdateAsset = createAction<{
  assetId: AssetId;
  asset: DeepPartial<AssetListItem>;
  forceUpdate: boolean;
}>(`${prefix}/PARTIAL_UPDATE_ASSET`);

export const updateAssetStatus = createAction<{
  assetId: AssetId;
  status: Status;
}>(`${prefix}/UPDATE_ASSET_STATUS`);

export const updateAssetHfsActions = createAction<{
  assetId: AssetId;
  previous: HfsAction[];
  updated: HfsAction[];
}>(`${prefix}/UPDATE_ASSET_HFS_ACTIONS`);

export const updateAssetLocation = createAction<{
  assetId: AssetId;
  location: LocationFields;
}>(`${prefix}/UPDATE_ASSET_LOCATION`);

export const updateAssetConnectivity = createAction<{
  assetId: AssetId;
  connectivity: AssetConnectivityUpdatedPayload;
}>(`${prefix}/UPDATE_ASSET_CONNECTIVITY`);

export const updateAssetPower = createAction<{
  assetId: AssetId;
  power: AssetPowerUpdatedPayload;
}>(`${prefix}/UPDATE_ASSET_POWER`);

export const updateAssetFirmware = createAction<{
  assetId: AssetId;
  version: string;
}>(`${prefix}/UPDATE_ASSET_FIRMWARE`);

export const updateAssetCSFirmware = createAction<{
  assetId: AssetId;
  version: string;
}>(`${prefix}/UPDATE_ASSET_CS_FIRMWARE`);

export const updateAssetOwnershipData = createAction<{
  assetId: AssetId;
  ownershipData: MachineOwnershipData;
}>(`${prefix}/UPDATE_ASSET_OWNERSHIP_DATA`);
